import client from "./client";

const sanitizeParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined && value !== null && value !== "" && !(typeof value === "string" && value.trim() === ""),
    ),
  );

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams(sanitizeParams(params)).toString();
  return query ? `?${query}` : "";
};

export const fetchAccountBookings = (params = {}) => {
  const query = buildQueryString(params);
  return client.get(`/portal/account/bookings${query}`);
};

export const fetchAccountSummary = () => client.get(`/portal/account/summary`);

export const fetchAccountRewards = (params = {}) => {
  const query = buildQueryString(params);
  return client.get(`/portal/account/rewards${query}`);
};

export const fetchAccountProfile = () => client.get(`/portal/account/profile`);

export const updateAccountProfile = (payload = {}) =>
  client.patch(`/portal/account/profile`, payload);

export const fetchAccountGuests = () => client.get(`/portal/account/guests`);

export const createAccountGuest = (payload = {}) =>
  client.post(`/portal/account/guests`, payload);

export const updateAccountGuest = (guestId, payload = {}) => {
  if (!guestId) {
    return Promise.reject(new Error("Guest ID is required"));
  }
  return client.patch(`/portal/account/guests/${encodeURIComponent(guestId)}`, payload);
};

export const deleteAccountGuest = (guestId) => {
  if (!guestId) {
    return Promise.reject(new Error("Guest ID is required"));
  }
  return client.delete(`/portal/account/guests/${encodeURIComponent(guestId)}`);
};

export const fetchAccountBooking = (referenceCode, params = {}, options = {}) => {
  if (!referenceCode) {
    return Promise.reject(new Error("Reference code is required"));
  }
  const query = buildQueryString(params);
  return client.get(`/portal/account/bookings/${encodeURIComponent(referenceCode)}${query}`, options);
};

export const fetchAccountReceiptDetails = (referenceCode) => {
  if (!referenceCode) {
    return Promise.reject(new Error("Reference code is required"));
  }
  return client.get(`/portal/account/bookings/${encodeURIComponent(referenceCode)}/receipt`);
};

export const fetchAccountPackageBookings = () => client.get(`/portal/account/package-bookings`);

export const fetchAccountPackageBooking = (packageRef) => {
  if (!packageRef) {
    return Promise.reject(new Error("Package reference is required"));
  }
  return client.get(`/portal/account/package-bookings/${encodeURIComponent(packageRef)}`);
};
